import { parse as parseQueryParams } from 'querystring';

/**
 * getLanguageQueryParam - Returns the 'lang' query param if it exists
 * If multiple exist we take the first.
 * @returns {string|null} queryParam
 */
export const getLanguageQueryParam = () => {
    const { lang } = parseQueryParams(window.location.search?.slice(1)) || {};
    if (typeof lang === 'string' || lang instanceof String) {
        return lang;
    }
    if (Array.isArray(lang) && lang.length > 0) {
        return lang[0];
    }
    return null;
};
